module.exports = __webpack_public_path__ + "static/media/live-event.33298264.svg";